import React from 'react';
import ItemOrderModal from '../Modal/ItemOrderModal';
import { formatCurrency } from '../../../utils/SamuiUtils';

const ItemOrderTable = ({
  mode,
  showItemModal,
  handleItemClose,
  itemDataList,
  onRowSelectItem,
  formDetailList,
  setFormDetailList,
  selectedItems,
  setSelectedItems,
  selectedStockItems,
  setSelectedStockItems,
  handleItemShow,
  handleQuantityChange,
  handleFocus,
  handleBlur,
  handleRemoveRow,
  odDataList,
  onRowSelectOd,
  disabled
}) => {
  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h4 className="card-title">รายละเอียดสินค้า</h4>
        <button
          className="btn text-white mx-3"
          onClick={handleItemShow}
          style={{
            backgroundColor: 'rgb(239, 108, 0)',
            whiteSpace: 'nowrap',
            padding: '10px',
            fontSize: '15px'
          }}
        >
          <i className="fa fa-plus"></i> เพิ่มรายการ
        </button>
      </div>
      <ItemOrderModal
        mode={mode}
        showItemModal={showItemModal}
        handleItemClose={handleItemClose}
        itemDataList={itemDataList}
        onRowSelectItem={onRowSelectItem}
        formDetailList={formDetailList}
        setFormDetailList={setFormDetailList}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        selectedStockItems={selectedStockItems}
        setSelectedStockItems={setSelectedStockItems}
        odDataList={odDataList}
        onRowSelectOd={onRowSelectOd}
      />
      <div className="card-body">
        <div className="table-responsive" style={{ maxHeight: '500px', overflowY: 'auto' }}>
          <table id="basic-datatables" className="table table-striped table-hover">
            <thead className="thead-dark">
              <tr>
                <th className="text-center" style={{ width: '2%' }}>#</th>
                <th className="text-center" style={{ width: '10%' }}>เลขเอกสาร</th>
                <th className="text-center" style={{ width: '8%' }}>รหัสสินค้า</th>
                <th className="text-center" style={{ width: '30%' }}>ชื่อสินค้า</th>
                <th className="text-center" style={{ width: '10%' }}>Todo</th>
                <th className="text-center" style={{ width: '10%' }}>จำนวนคงคลัง</th>
                <th className="text-center" style={{ width: '10%' }}>จำนวนเบิก</th>
                <th className="text-center" style={{ width: '10%' }}>จำนวนคงเหลือ</th>
                <th className="text-center" style={{ width: '5%' }}>หน่วย</th>
                <th className="text-center" style={{ width: '5%' }}>ลบ</th>
              </tr>
            </thead>
            <tbody>
              {formDetailList.length > 0 ? (
                formDetailList.map((item, index) => (
                  <tr key={item.itemId || index + 1}>
                    {/* # */}
                    <td className="text-center">{index + 1}</td>

                    {/* เลขเอกสาร */}
                    <td className="text-center">
                      <span>{item.refDocNo || '-'}</span>
                    </td>

                    {/* รหัสสินค้า */}
                    <td className="text-center">
                      <span>{item.itemCode || ''}</span>
                    </td>

                    {/* ชื่อสินค้า */}
                    <td className="text-left">
                      <span>{item.itemName || ''}</span>
                    </td>

                    {/* Todo */}
                    <td className="text-center">
                      <span>{item.docType || ''}</span>
                    </td>

                    {/* จำนวนคงคลัง */}
                    <td className="text-center">
                      <span>{formatCurrency(item.itemOnHand || 0)}</span>
                    </td>

                    {/* จำนวน */}
                    <td className="text-center">
                      <input
                        type="text"
                        className="form-control text-center"
                        value={item.itemDecrease || ''}
                        onChange={(e) => handleQuantityChange(index, 'decrease', e.target.value, item.itemOnHand)}
                        onFocus={(e) => handleFocus(index)}
                        onBlur={(e) => handleBlur(index)}
                        onInput={(e) => {
                          const inputValue = e.target.value;
                          if (!/^(0|[1-9]\d*)(\.\d*)?$/.test(inputValue)) {
                            e.target.value = inputValue.slice(0, -1);
                          }
                        }}
                        disabled={disabled || item.refDocNo}
                      />
                    </td>

                    {/* จำนวนคงเหลือ */}
                    <td className="text-center">
                      <span>{formatCurrency(item.itemBalance || 0)}</span>
                    </td>

                    {/* หน่วย */}
                    <td className="text-center">
                      <span>{item.itemUnit || ''}</span>
                    </td>

                    {/* ลบ */}
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-danger"
                        disabled={disabled}
                        onClick={() => handleRemoveRow(index, item.refDocNo)}>
                        ลบ
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10">
                    <center>
                      <h5>ไม่พบรายการสินค้า</h5>
                    </center>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div >
  );
};

export default ItemOrderTable;